import FileDropZone from "components/FileDropZone/FileDropZone";
import styled from "styled-components";

// Room between the table above and the Save row below.
export const Zone = styled(FileDropZone)`
  margin: 16px 5px 24px;
`;

export const Hint = styled.div<{ $warning: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  background: ${({ theme, $warning }) =>
    $warning ? theme.warningBg : theme.lightgrey03};
  border: 1px solid
    ${({ theme, $warning }) => ($warning ? theme.warningBorder : "transparent")};
  color: ${({ theme, $warning }) =>
    $warning ? theme.warningText : theme.textSecondary};
`;

export const ApplyButton = styled.button`
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  color: inherit;
  font: inherit;
`;
